import cn from 'classnames';
import { Carousel } from './carousel-inner';

function GenericSlider({
  slides,
  onSlideChange,
  hidePositionIndicators,
  currentSlideIndex = 0,
  cyclic,
  autoPlayInterval,
  autoPlay,
  id,
  showArrows,
  className
}) {
  return (
    <div className="snf-lx-components-common-carousel-generic-slider">
      <>
        {slides?.length > 0 ? (
          <Carousel
            autoPlay={autoPlay}
            autoPlayInterval={autoPlayInterval}
            currentSlideIndex={currentSlideIndex}
            slidesLength={slides?.length}
            onSlideChange={onSlideChange}
            cyclic={cyclic}
            id={id}
            showArrows={showArrows}
            hidePositionIndicators={hidePositionIndicators}
          >
            {slides?.map((slide, index) => (
              <div key={`slide_div-item_${index + 1}`} className={cn('div-item', className)}>
                {slide}
              </div>
            ))}
          </Carousel>
        ) : null}
      </>
    </div>
  );
}

GenericSlider.displayName = 'GenericSlider - Util';
export { GenericSlider };
